import { trafficLightSections } from '@hdcorner/ui-library';

const getTipTitle = (value: string) => {
  const found = trafficLightSections.find(item => item.value === value);
  return found ? found.label : '';
};

export { getTipTitle };
